import { render, staticRenderFns } from "./searchTemplate.vue?vue&type=template&id=1baf8a7e&scoped=true"
import script from "./searchTemplate.vue?vue&type=script&lang=js"
export * from "./searchTemplate.vue?vue&type=script&lang=js"
import style0 from "./searchTemplate.vue?vue&type=style&index=0&id=1baf8a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf8a7e",
  null
  
)

export default component.exports